import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import GetFeedbackByCompanyIdRequestModel from '../../../../services/v2/model/get-feedback-by-company-id-request-model';
import LookupRequestModel from '../../../../services/v2/model/lookup-request-model';
import EventPageBase from '../../_base/EventPageBase';
import GuidEventLookupModel from '../../../../services/v2/model/guid-event-lookup-model';

export default class CompanyDashboardPage extends EventPageBase {
  public get companyFeedbacksList() {
    if (this.companyFeedback.data !== undefined && this.companyFeedback.data.items !== undefined) {
      return this.companyFeedback.data?.items?.map((record) => ({
        id: record.data.id,
        companyId: record.data.companyId,
        eventRating: Vue.$tEnum('page.dashboard.companies.feedbacks.enum.eventRating', record.data.eventRating!),
        reparticipationRating: Vue.$tEnum('page.dashboard.companies.feedbacks.enum.reparticipationRating', record.data.reparticipationRating!),
        youthVisitorsCount: record.data.youthVisitorsCount,
        adultVisitorsCount: record.data.adultVisitorsCount,
        remark: record.data.remark,
      }));
    }
    return [];
  }

  public set companyFeedbacksList(value) { /* Do nothing */ }

  public eventItems: GuidEventLookupModel[] | undefined;

  public companiesDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.tdg_Companies.getCompanyForUser,
  });

  public companyFeedback = new DataSource({
    selectCommand: () => {
      const request = new GetFeedbackByCompanyIdRequestModel();
      request.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      request.companyId = this.companyId;
      return Vue.$service.v2.api.tdg_Feedbacks.getFeedbackByCompanyId(request);
    },
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    await this.loadCompanyDataSource();
    this.companyFeedback.filter.companyId = this.companyId;
    await this.companyFeedback.select();
  }

  public redirectToFeedback() {
    if (this.companyFeedbacksList && this.companyFeedbacksList.length > 0) {
      Vue.$router.push('/tourdegwaerb/company/feedbacks/edit');
    } else {
      Vue.$router.push('/tourdegwaerb/company/feedbacks/create');
    }
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
      }
    }
  }
}
